module.exports = __webpack_public_path__ + "static/media/residentAccountRequest.6c0df2a5.png";